import React from 'react';
import PropTypes from 'prop-types';
import CrmLineItem from '../../../classes/CrmLineItem';
import { CurrencyType } from '../../../utility/types/CurrencyTypes';

function LineItemTable({
  lineItems,
  tax, grandTotal, shippingCost, shippingDetailsString, currencyType, calculatingTotals,
}) {
  return (
    <>
      <div className="table-responsive">
        <table className="table table-sm table-striped mt-5">
          <thead>
            <tr>
              <th>Item</th>
              <th className="text-right">Price</th>
              <th className="text-right">Quantity</th>
              <th className="text-right">Discount</th>
              <th className="text-right">Total</th>
            </tr>
          </thead>
          <tbody>
            {lineItems.map((item, index) => (
              <tr key={index}>
                <td>
                  {item.description}
                </td>
                <td className="text-right">
                  {item.listPriceDisplay}
                </td>
                <td className="text-right">
                  {item.quantity}
                </td>
                <td className="text-right">
                  {item.discountDisplay}
                </td>
                <td className="text-right">
                  {item.totalPrice}
                </td>
              </tr>
            ))}
            <tr>
              <td>
                Shipping
                {`: ${shippingDetailsString}`}
              </td>
              <td />
              <td />
              <td />
              <td className="text-right">
                {shippingCost}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
      <div className="row">
        <div className="col">
          {currencyType === CurrencyType.EUR
            ? (<h5>VAT / Tax</h5>)
            : <h5>Tax</h5>}
        </div>
        <div className="col-auto ml-auto">
          {calculatingTotals
            ? (<span>Calculating...</span>)
            : (<h5>{tax}</h5>)}
        </div>
      </div>
      <div className="row">
        <div className="col">
          <h4>Total</h4>
        </div>
        <div className="col-auto ml-auto">
          {calculatingTotals
            ? (<span>Calculating...</span>)
            : (<h4>{grandTotal}</h4>)}
        </div>
      </div>
    </>
  );
}

LineItemTable.defaultProps = {
  shippingDetailsString: '',
  calculatingTotals: false,
};

LineItemTable.propTypes = {
  lineItems: PropTypes.arrayOf(PropTypes.shape(CrmLineItem)).isRequired,
  tax: PropTypes.string.isRequired,
  grandTotal: PropTypes.string.isRequired,
  shippingCost: PropTypes.string.isRequired,
  shippingDetailsString: PropTypes.string,
  currencyType: PropTypes.number.isRequired,
  calculatingTotals: PropTypes.bool,
};

export default LineItemTable;
